const externals = {
    'configData':
    {
        mode: 'production', // "production" | "development" | "none"
        version: 'v1.0.4',
        build: '1.2.1',
        release_date: '13-05-2021'
    }
}

export default externals;
